<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="inspectedRcvdBy_tooltip_NAME"
      :name="inspectedRcvdBy_tooltip_NAME" :description="inspectedRcvdBy_tooltip_DESCRIPTION"
      :editable="editable"></tool-tip>
    <div class="row">
      <div class="col-md-6">
        <el-alert v-if="isPartial" type="warning" :closable="false" title="Module Incomplete"
          description="The module will remain incomplete until complete radio button is selected in this module" show-icon
          effect="dark">
        </el-alert>
      </div>
    </div>
    <!-- <div v-if="duringSubmit" class="loading">
      <Loading/>
    </div> -->
    <div class="row justify-content-left more-bottom-padding">
      <div class="col-md-4">


        <label>Partial or Completed Delivery of Initial LSSS:</label>
        <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="initial_lsss_tooltip_name"
          :name="initial_lsss_tooltip_name" :description="initial_lsss_tooltip_description"
          :editable="editable"></tool-tip>
        <br />
        <input type="radio" v-validate="'required'" name="partialInspectedReceivedByCompleted"
          data-vv-as="Delivery of Initial LSSS"
          :disabled="(!isLegacyOrder && isReceived) || isReadOnly || checkForPartnerNationCondition || isReceived"
          id="PartialRadio" :value="true" v-model="inspectedReceivedBy.isPartial" />
        <label for="PartialRadio" class="ml-1">Partial</label>
        <br />
        <input type="radio" v-validate="'required'" name="partialInspectedReceivedByCompleted"
          data-vv-as="Delivery of Initial LSSS"
          :disabled="(!isLegacyOrder && isReceived) || isReadOnly || checkForPartnerNationCondition || isReceived"
          id="CompleteRadio" :value="false" v-model="inspectedReceivedBy.isPartial" />
        <label for="CompleteRadio" class="ml-1"> Complete</label>
        <br>
        <span v-show="errors.has('partialInspectedReceivedByCompleted')" class="error">{{
          errors.first("partialInspectedReceivedByCompleted") }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label for="inspectedName">Name (Last, First, MI, Rank / Title)</label>
        <base-input :disabled="isReadOnly || isReceived || checkForPartnerNationCondition || isReceived" data-vv-as="Name"
          v-model="inspectedReceivedBy.receiverName" name="inspectedName" v-validate="'required|max:300'"
          :error="getError('inspectedName')">
        </base-input>
      </div>
      <div class="col-md-6">
        <label for="receivingOffice">Receiving Unit / Office</label>
        <base-input :disabled="isReadOnly || isReceived || checkForPartnerNationCondition || isReceived"
          v-model="inspectedReceivedBy.receiverUnitOffice" name="receivingUnitOffice" data-vv-as="Receiving Unit / Office"
          v-validate="'required|max:300'" :error="getError('receivingUnitOffice')">
        </base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label for="receivingNation">Receiving Nation / Organization</label>
        <v-select id="receivingNation"
          :disabled="isReadOnly || isReceived || checkForPartnerNationCondition || isReceived"
          v-model="inspectedReceivedBy.receiverOrganizationId" :reduce="(organizationOption) => organizationOption.id"
          name="receivingNation" label="name" data-vv-as="Receiving Nation / Organization"
          :options="inspectedReceivedBy.organizations" placeholder="Select one"
          :class="errors.has('receivingNation') ? 'has-danger' : ''" v-validate="'required'"
          :error="getError('receivingNation')"></v-select>
        <span v-show="errors.has('receivingNation')" class="error">{{ errors.first("receivingNation") }}
        </span>
      </div>
      <div class="col-md-6">

        <!-- verify Pin Code -->.
        <verify-pin v-if="isSigned" :checkForPartnerNationCondition="checkForPartnerNationCondition" :isPartnerAccount="isPartnerAccount"
          :isReadOnly="isReadOnly" v-on:pinVerify="pinVerify" />

        <AlertSignature ref="alertInspectedReceivedBySignatureGraphical" :headerText="'Inspected/Received By Signature'"
          :module="'inspectedReceivedBy'" :action="'getInspectedReceivedBy'" 
          v-on:onUpload="fileUploaded"
          :isPinVerified="isPinVerificationDone" v-on:onSigned="onSigned"
          :activeTab="inspectedReceivedBy.receiverSignature.type" :signatureData="inspectedReceivedBy.receiverSignature"
          :fileTypeId="2" :textDisabled="checkForPartnerNationCondition || isReceived || isReadOnly"
          :drawDisabled="checkForPartnerNationCondition || isReceived || isReadOnly"
          :uploadDisabled="isPartnerAccount || isReceived || isReadOnly"
          :certificateDisabled="isPartnerAccount || isReceived || isReadOnly || !signedInWithCac" />
        <label style="margin-left: 5px; margin-right: 5px" v-if="isUsSellOrder && !isPartnerAccount">or</label>


        <request-signature :signatureUrl="`api/receivedsignatures/request/${getOrderIdFromRoute}`"
          :requestDate="inspectedReceivedBy.receiverDateRequested" :isDisabled="isRequestDisabled"
          v-bind:moduleSubmit="submit" v-if="isUsSellOrder && !isPartnerAccount"></request-signature>

        <div v-if="hasSignatureImage()" class="container signature_content_padding_top_small signature_field">
          <div class="row justify-content-end">
            <delete-signature :headerText="'Are you sure you want to remove the Receipt Signature?'"
            :signatureId="inspectedReceivedBy.receiverSignature.signatureId"
            :fileTypeId="2"
            :signatureType="inspectedReceivedBy.receiverSignature.type"
            :disabled="isPartnerAccount || isReceived"
            v-on:modal-closed="reloadData"></delete-signature>
          </div>

          <img class="image_layout" :src="inspectedReceivedBy.receiverSignature.view" height="100">
        </div>

        <div>
          <div class="less-top-padding">
            <label>Signature Date</label>
            <el-date-picker
              :disabled="(isReceived && !isLegacyOrder) || isReadOnly || isPartnerAccount || isReceived || (!isRelevantDocumentUploaded && !fileUploadedBoolean)"
              v-model="inspectedReceivedBy.receiverDateSigned" type="date" :editable="false" format="dd-MMMM-yyyy"
              data-vv-as="Signature Date" name="dateSigned" :class="errors.has('dateSigned') ? 'has-danger' : ''"
              :error="getError('dateSigned')"
              @change="handleDateChange">
            </el-date-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12">
        <div class="pull-right">
          <base-button type="primary" :disabled="isReadOnly || isReceived || checkForPartnerNationCondition || isReceived"
            wide @click.native="submit" class="btn-next">Save</base-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertSignature from "@/components/App/signatures/AlertSignature.vue";
import RequestSignature from "@/components/App/signatures/RequestSignature.vue";
import DeleteSignature from "@/components/App/signatures/DeleteSignature.vue";
import VerifyPin from '@/components/App/order/VerifyPin.vue';
import { mapGetters, mapActions } from "vuex";
import Util from "@/util/util";
import { Alert, Button } from "element-ui";
import Loading from 'src/components/LoadingPanel';
import toolTip from "../../Tooltip";
import BaseButton from '../../../BaseButton.vue';
import { EventBus } from "@/event-bus.js";

export default {
  props: ["isReadOnly"],
  name: "InspectedReceivedBy",
  data() {
    return {
      isBuyTransaction: true,
      duringSubmit: false,
      initial_lsss_tooltip_name: '',
      initial_lsss_tooltip_description: '',
      inspectedRcvdBy_tooltip_NAME: '',
      inspectedRcvdBy_tooltip_DESCRIPTION: '',
      fileUploadedBoolean: false,
      isPinVerificationDone: false,
      pin: null,
      sigHasSigned: false
    };
  },
  components: {
    AlertSignature,
    [Alert.name]: Alert,
    [Button.name]: Button,
    RequestSignature,
    DeleteSignature,
    Loading,
    toolTip,
    BaseButton,
    VerifyPin,
    EventBus
  },
  async mounted() {
    let ctx = this;

    await ctx.getAllTooltips()
    ctx.loadToolTips();

    EventBus.$on('pn-user-change', async (value) => {
      this.getInspectedReceivedBy(this.getOrderIdFromRoute);
    });

    EventBus.$on('doc-type-change', async() => {
      ctx.$loaderApp.addRequest();
      await ctx.getInspectedReceivedByStatus(ctx.$route.params.id);
      ctx.$loaderApp.completeRequest();
    });
  },
  computed: {
    ...mapGetters({
      inspectedReceivedBy: "inspectedReceivedBy/inspectedReceivedBy",
      preOrderStatus: "preOrderDetail/preOrderStatus",
      agreementInformationStatus: "agreementInformation/agreementInformationStatus",
      inspectedReceivedByHelper: "inspectedReceivedBy/inspectedReceivedByHelper",
      inspectedReceivedByErrors: "inspectedReceivedBy/inspectedReceivedByErrors",
      isAuthorized: "orderMetadata/isAuthorized",
      documents: "documents/getDocuments",
      getUser: "authentication/getUser",
      order: 'order/order',
      orderMetadata: "orderMetadata/orderMetadata",
      isReceived: "orderMetadata/isReceived",
      isPartnerAccount: "authentication/isPartnerAccount",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
      isUsSellOrder: "preOrderDetail/isUsSellOrder",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    isSigned() {
      if(this.inspectedReceivedBy.receiverDateRequested){
        if(!this.inspectedReceivedBy.receiverSignature.signatureId){
          return true
        }else return false
      }else return false
    },
    isRequestDisabled() {
      return !this.inspectedReceivedBy.receiverName || !this.inspectedReceivedBy.receiverUnitOffice || !this.inspectedReceivedBy.receiverOrganizationId
        || this.inspectedReceivedBy.receiverDateRequested ? true : false || this.inspectedReceivedBy.receiverSignature.view ? true : false || !this.isAuthorized || this.isReadOnly

    },
    isLegacyOrder() {
      return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
    checkForPartnerNationCondition() {
      if (this.isPartnerAccount && this.isUsSellOrder) {
        if (this.inspectedReceivedBy.receiverDateRequested == null) {
          return true;
        }
        return false;
      }
      else if (this.isPartnerAccount && this.isUsBuyOrder) {
        return true;
      }
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    isPartial() {
      return this.inspectedReceivedBy.isPartial;
    },
    signedInWithCac() {
      return this.getUser.loginMethod == "CAC";
    },
    isRelevantDocumentUploaded() {
      if (this.documents && this.documents.length > 0) {
        return this.documents.some(document => {
          return document.fileTypeNames.some(doc => doc === Util.RECEIVING_REPORT);
        });
      }
      return false
    },
    signatureDateAddedWithSignatureOrDocumentUploaded() {
      return this.isRelevantDocumentUploaded || this.hasSignatureImage() || this.signedInWithCac;
    }
  },
  methods: {
    ...mapActions({
      getInspectedReceivedBy: "inspectedReceivedBy/getInspectedReceivedBy",
      getInspectedReceivedByStatus:
        "inspectedReceivedBy/getInspectedReceivedByStatus",
      getInspectedReceivedByHelper:
        "inspectedReceivedBy/getInspectedReceivedByHelper",
      saveInspectedReceivedBy: "inspectedReceivedBy/saveInspectedReceivedBy",
      getAllTooltips: "tooltip/getToolTips",
      getInspectedReceivedBySigOnly: "inspectedReceivedBy/getInspectedReceivedBySigOnly"
    }),
    pinVerify(val, pin) {
      this.isPinVerificationDone = val;
      this.pin = pin;
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
    },
    async onSigned() {
      // complete the request
      this.sigHasSigned = true;
      await this.submit();
      // only pn user will use this
      this.pin = null;
    },
    async fileUploaded() {
      this.fileUploadedBoolean = true;
      // reload sig to get the new view
      await this.getInspectedReceivedBySigOnly(this.getOrderIdFromRoute);
      await this.submit();
      this.$loaderApp.completeRequest();//loader has complete request.

    },
    loadToolTips() {
      const initialToolTip = this.toolTips.find(e => e.name === "InitialLSSS")
      const inspectedRcvdByVal = this.toolTips.find(e => e.name === "InspectedSignatureModule")

      if (initialToolTip && initialToolTip.status) {

        this.initial_lsss_tooltip_description = initialToolTip.description ? initialToolTip.description : null
        this.initial_lsss_tooltip_name = initialToolTip.name ? initialToolTip.name : null
      }
      if (inspectedRcvdByVal && inspectedRcvdByVal.status) {
        this.inspectedRcvdBy_tooltip_DESCRIPTION = inspectedRcvdByVal.description ? inspectedRcvdByVal.description : null
        this.inspectedRcvdBy_tooltip_NAME = inspectedRcvdByVal.name ? inspectedRcvdByVal.name : null
      }
      return
    },
    updateToolTip(updatedData) {
      this.loadToolTips()
    },
    loaded() {
      let ctx = this;
      ctx.getInspectedReceivedByHelper(ctx.getOrderIdFromRoute).then(() => {
        const params = {
          buySell: ctx.inspectedReceivedByHelper.buySell,
          countryId: ctx.inspectedReceivedByHelper.countryId,
          preOrderDetailStatus: ctx.preOrderStatus,
          agreementInformationStatus: ctx.agreementInformationStatus,
        };

        this.isBuyTransaction = params.buySell == "BUY";

        ctx.$store.dispatch(
          "inspectedReceivedBy/getOrganizations",
          params
        );
        ctx.getInspectedReceivedBy(this.getOrderIdFromRoute);
      });
    },

    hasSignatureImage() {
      return !Util.isNullOrEmpty(this.inspectedReceivedBy.receiverSignature.view);
    },

    async reloadData() {
      await this.getInspectedReceivedByStatus(this.getOrderIdFromRoute);
          await this.getInspectedReceivedBy(this.getOrderIdFromRoute);
    },


    async submit(e) {
      var result = await this.$validator.validateAll();
      if (result) {
        //this.duringSubmit = true;
        this.$loaderApp.addRequest();
        if (!this.signatureDateAddedWithSignatureOrDocumentUploaded && (this.inspectedReceivedBy.receiverDateSigned)) {
          this.$toast.error(Util.SIGNATURE_DATE_ADDED_WITHOUT_SIGNATURE_OR_DOCUMENT_UPLOADED);
        } else {
          var ctx = this;
          let data = {
            orderId: this.getOrderIdFromRoute,
            pin: (this.sigHasSigned || this.fileUploadedBoolean) ? this.pin : ''
          };
          await this.saveInspectedReceivedBy(data);

          await this.getInspectedReceivedByStatus(ctx.getOrderIdFromRoute);

          await this.getInspectedReceivedBy(ctx.getOrderIdFromRoute);
          //this.duringSubmit = false;
          //this.$loaderApp.completeRequest();
          ctx.$toast.success("Inspected / Received Signature Module Saved");
        }
        this.$loaderApp.completeRequest();
      } else {
        //this.duringSubmit = false;
        this.$loaderApp.completeRequest();
        this.$toast.error("Please fill the required fields.");
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleDateChange(date) {
      // Force Vue to register the change and update the UI
      // This ensures the date is properly reflected in the UI even when page is still loading
      if (date) {
        this.$nextTick(() => {
          // Using $set to ensure reactivity
          this.$set(this.inspectedReceivedBy, 'receiverDateSigned', date);
        });
      }
    },
  },
};
</script>

<style scopped>
.row {
  margin-right: 0px!important;
  margin-left: 0px!important;
}
</style>
                                     